import React from 'react';

import Box from '@material-ui/core/Box';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';

import { DialogoCreateEdit } from '../../Components/modulo-gerencial-dialogos';
import { SwitchInput, TextInput } from '../../Components/modulo-gerencial-formularios';
import ControllerInput from '../../Components/modulo-gerencial-formularios/inputs/ControllerInput';
import {
  CATEGORIAS_ENDERECO_EXPOSICAO,
  CATEGORIA_ENDERECO_EXPOSICAO_PORTA_PALLET,
} from '../../utils/constants';

const OPCOES_ANDARES = [
  { valor: 1, label: '1 nível — Térreo' },
  { valor: 2, label: '2 níveis — Térreo + 1º Aéreo' },
  { valor: 3, label: '3 níveis — Térreo + 1º Aéreo + 2º Aéreo' },
];

function QuantidadeAndaresInput({ name }) {
  return (
    <ControllerInput
      name={name}
      render={({ field }) => (
        <Box mt={2}>
          <TextField
            {...field}
            select
            fullWidth
            variant="outlined"
            margin="normal"
            label="Quantidade de andares"
          >
            {OPCOES_ANDARES.map(({ valor, label }) => (
              <MenuItem key={valor} value={valor}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      )}
    />
  );
}

function CategoriaInput({ name }) {
  return (
    <ControllerInput
      name={name}
      render={({ field }) => (
        <Box mt={2}>
          <TextField
            {...field}
            select
            fullWidth
            variant="outlined"
            margin="normal"
            label="Categoria do endereço"
          >
            {CATEGORIAS_ENDERECO_EXPOSICAO.map(({ categoria, label }) => (
              <MenuItem key={categoria} value={categoria}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      )}
    />
  );
}

const initialValues = {
  codigo: '',
  quantidade_andares: 1,
  terreo_exposicao: false,
  categoria: CATEGORIA_ENDERECO_EXPOSICAO_PORTA_PALLET,
};

const validadores = {
  codigo: (value, values, config) => {
    if (value.length < 2) return 'Não pode ser menor que 2';
    if (value.length > 30) return 'Não pode ser maior que 30';
    return '';
  },
  quantidade_andares: (value, values, config) => {
    if (![1, 2, 3].includes(value)) return 'Selecione a quantidade de andares';
    return '';
  },
  categoria: (value, values, config) => {
    if (!value) return 'Selecione a categoria';
    return '';
  },
};

const transformGetDados = (dados, config) => ({
  codigo: dados.codigo,
  quantidade_andares: dados.quantidade_andares || 1,
  terreo_exposicao: !!dados.terreo_exposicao,
  categoria: dados.categoria || CATEGORIA_ENDERECO_EXPOSICAO_PORTA_PALLET,
});

const transformSalvar = (dados, config) => ({
  codigo: dados.codigo,
  quantidade_andares: dados.quantidade_andares,
  terreo_exposicao: dados.terreo_exposicao,
  categoria: dados.categoria,
});

function Form() {
  return (
    <div>
      <TextInput
        name="codigo"
        fullWidth
        label="Descrição do endereço"
        autoFocus
      />
      <QuantidadeAndaresInput name="quantidade_andares" />
      <CategoriaInput name="categoria" />
      <Box mt={2}>
        <SwitchInput
          name="terreo_exposicao"
          label="Térreo é exposição em loja (não é usado em entradas, saídas, movimentações ou compra)"
        />
      </Box>
    </div>
  );
}

const Dialogo = ({ onClose, open, id, isDialogoConfirmacaoActions }) => (
  <DialogoCreateEdit
    open={open}
    id={id}
    initialValues={initialValues}
    validators={validadores}
    resource="enderecos_exposicao_mercadorias"
    titleCreate="Novo Endereço"
    titleUpdate="Editar Endereço"
    onClose={onClose}
    transformGetDados={transformGetDados}
    transformSalvar={transformSalvar}
    isCloseTitle
    isDialogoConfirmacaoActions={isDialogoConfirmacaoActions}
  >
    <Form />
  </DialogoCreateEdit>
);

export default Dialogo;
